/**
 * Environment Configuration
 *
 * Uses react-native-ultimate-config to load environment variables at build time.
 * Create .env.production and .env.test files in the project root.
 *
 * Android: flavors auto-pick env via flavorEnvMapping in build.gradle
 *   Production: npm run android:production (productionDebug)
 *   Test:       npm run android:test (stagingDebug)
 *
 * iOS: schemes auto-run rnuc via pre-build scripts
 *   Production: npm run ios:production (OneApp-Production scheme)
 *   Test:       npm run ios:test (OneApp-Test scheme)
 */

import Config from 'react-native-ultimate-config';

export type Environment = 'development' | 'staging' | 'production' | 'test';

// Read from environment variables with fallback to production defaults
export const API_BASE_URL = Config.API_BASE_URL || 'https://api.l2io.ai';
export const ENVIRONMENT = (Config.ENVIRONMENT as Environment) || 'production';
export const FIREBASE_PROJECT_ID = Config.FIREBASE_PROJECT_ID || 'tone-72f83';

console.log('Config loaded:', {
  API_BASE_URL,
  ENVIRONMENT,
  FIREBASE_PROJECT_ID,
  raw: Config,
});

// Legacy config object for backwards compatibility
interface EnvironmentConfig {
  apiBaseUrl: string;
  environment: Environment;
  firebaseProjectId: string;
}

export const config: EnvironmentConfig = {
  apiBaseUrl: API_BASE_URL,
  environment: ENVIRONMENT,
  firebaseProjectId: FIREBASE_PROJECT_ID,
};

export default config;
